import {trackEvent} from '~/utils/productAnalytics';

export type UpgradeSource =
  | 'general_upgrade'
  | 'onboarding'
  | 'business_unit'
  | 'buyer_persona'
  | 'contact_export_limit'
  | 'intent_topics'
  | 'bu-tam'
  | 'funnel_vision'
  | 'icp_segment';

export type UpgradeTargetPlan = 'free' | 'reveal' | 'target';

export default defineNuxtPlugin(async () => {
  const toast = useToast();
  const isLoadingModalOpen = useState('isLoadingModalOpen');

  const upgrade = async (
    targetPlan: UpgradeTargetPlan,
    upgradeSource: UpgradeSource,
    toastOptions?: {title: string; description: string}
  ) => {
    trackEvent('upgrade_prompt_shown', {
      target_plan: targetPlan,
      source: upgradeSource || 'general_upgrade',
      has_toast_message: !!toastOptions,
    });

    isLoadingModalOpen.value = true;
    await navigateTo(`/settings/billing?plan=${targetPlan}`);

    isLoadingModalOpen.value = false;
    if (toastOptions) {
      setTimeout(() => {
        toast.add({
          title: toastOptions.title,
          description: toastOptions.description,
        });
      }, 2000);
    }
  };

  return {
    provide: {
      upgrade,
    },
  };
});
